import 'babel-polyfill'
import 'whatwg-fetch'
import './sentry'

import React from 'react'
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import { parse } from 'query-string'

import {
  osName
} from "react-device-detect";

import App from './components/App'

import { setTheme, setOs, setPopinfoId } from './actions'

import configureStore from './store'
const store = configureStore()

import './stylesheets/main.scss'

const themeMatch = window.navigator.userAgent.match(/ThemeName:(default|sounyan|train)/)
const themeName = themeMatch ? themeMatch[1] : 'default'
store.dispatch(setTheme(themeName))
store.dispatch(setOs(osName))
const query = parse(location.search)
const popinfoId = query['popinfo_id']
store.dispatch(setPopinfoId(popinfoId))

// ページタイトル
if (location.pathname.indexOf('nankai') > 0) {
  document.title = "南海線"
} else if (location.pathname.indexOf('koya') > 0){
  document.title = "高野線"
}

ReactDOM.render((
  <Provider store={store}>
    <Router>
      <Route component={App} />
    </Router>
  </Provider>
), document.getElementById('root'))
